/* cls-women.js — Celestium Women collection: filter/sort/quick-view engine
   Source: Celestium Women Collection.dc.html (client-side filtering reimplemented in vanilla JS
   against real Shopify product data rendered server-side by cls-product-grid.liquid). */
(function () {
  'use strict';

  var COLOR_NAMES = { '#111111': 'Ink', '#E6D5C3': 'Sand', '#B8975A': 'Gold', '#D8D2C4': 'Stone', '#FAFAFA': 'Chalk', '#6B6257': 'Ash' };

  var state = {
    sort: 'featured',
    category: 'All',
    sizes: [],
    colors: [],
    availability: 'All',
    priceMax: 900,
    density: 'comfortable'
  };

  var wishlist = {};
  try { wishlist = JSON.parse(localStorage.getItem('cls_wishlist') || '{}'); } catch (e) { wishlist = {}; }

  var toastTimer = null;
  function showToast(text) {
    var toast = document.querySelector('[data-cls-toast]');
    if (!toast) return;
    clearTimeout(toastTimer);
    toast.querySelector('[data-cls-toast-text]').textContent = text;
    toast.classList.add('is-visible');
    toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 2600);
  }

  function money(cents) {
    return '$' + (Math.round(cents * 100) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* ---------- Header offset for sticky toolbar ---------- */
  function syncToolbarOffset() {
    var wrap = document.querySelector('[data-cls-toolbar-wrap]');
    var header = document.querySelector('.cls-header-wrap');
    if (!wrap) return;
    var h = header ? header.offsetHeight : 0;
    wrap.style.top = h + 'px';
  }

  /* ---------- Scroll elevation ---------- */
  function onScroll() {
    var wrap = document.querySelector('[data-cls-toolbar-wrap]');
    if (wrap) wrap.classList.toggle('is-elevated', window.scrollY > 300);
  }

  /* ---------- Dropdowns ---------- */
  function initDropdowns() {
    var dds = document.querySelectorAll('[data-cls-dd]');
    dds.forEach(function (dd) {
      var toggle = dd.querySelector('[data-cls-dd-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = dd.classList.contains('is-open');
        dds.forEach(function (o) { o.classList.remove('is-open'); });
        if (!isOpen) dd.classList.add('is-open');
      });
    });
    document.addEventListener('click', function () {
      dds.forEach(function (o) { o.classList.remove('is-open'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') dds.forEach(function (o) { o.classList.remove('is-open'); });
    });
  }

  /* ---------- Filter controls ---------- */
  function initSort() {
    var labels = { featured: 'Featured', new: 'Newest', low: 'Price: Low to High', high: 'Price: High to Low' };
    document.querySelectorAll('[data-cls-sort-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.sort = btn.getAttribute('data-cls-sort-opt');
        document.querySelectorAll('[data-cls-sort-opt]').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-cls-sort-opt') === state.sort);
        });
        var labelEl = document.querySelector('[data-cls-sort-label]');
        if (labelEl) labelEl.textContent = labels[state.sort];
        closeDropdowns();
        render();
      });
    });
  }

  function initCategory() {
    document.querySelectorAll('[data-cls-cat-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.category = btn.getAttribute('data-cls-cat-opt');
        document.querySelectorAll('[data-cls-cat-opt]').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-cls-cat-opt') === state.category);
        });
        closeDropdowns();
        render();
      });
    });
  }

  function initSize() {
    document.querySelectorAll('[data-cls-size-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = btn.getAttribute('data-cls-size-opt');
        var idx = state.sizes.indexOf(val);
        if (idx >= 0) state.sizes.splice(idx, 1); else state.sizes.push(val);
        document.querySelectorAll('[data-cls-size-opt="' + val + '"]').forEach(function (b) {
          b.classList.toggle('is-active', state.sizes.indexOf(val) >= 0);
        });
        render();
      });
    });
  }

  function initColor() {
    document.querySelectorAll('[data-cls-color-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = btn.getAttribute('data-cls-color-opt');
        var idx = state.colors.indexOf(val);
        if (idx >= 0) state.colors.splice(idx, 1); else state.colors.push(val);
        document.querySelectorAll('[data-cls-color-opt="' + val + '"]').forEach(function (b) {
          b.classList.toggle('is-active', state.colors.indexOf(val) >= 0);
        });
        closeDropdowns();
        render();
      });
    });
  }

  function initAvailability() {
    document.querySelectorAll('[data-cls-avail-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.availability = btn.getAttribute('data-cls-avail-opt');
        document.querySelectorAll('[data-cls-avail-opt]').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-cls-avail-opt') === state.availability);
        });
        closeDropdowns();
        render();
      });
    });
  }

  function initPrice() {
    document.querySelectorAll('[data-cls-price-range]').forEach(function (input) {
      input.addEventListener('input', function () {
        state.priceMax = Number(input.value);
        document.querySelectorAll('[data-cls-price-range]').forEach(function (i) { i.value = state.priceMax; });
        document.querySelectorAll('[data-cls-price-label]').forEach(function (l) { l.textContent = state.priceMax; });
        render();
      });
    });
  }

  function initDensity() {
    document.querySelectorAll('[data-cls-density]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.density = btn.getAttribute('data-cls-density');
        document.querySelectorAll('[data-cls-density]').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-cls-density') === state.density);
        });
        document.querySelectorAll('[data-cls-grid]').forEach(function (g) {
          g.classList.toggle('is-compact', state.density === 'compact');
        });
      });
    });
  }

  function closeDropdowns() {
    document.querySelectorAll('[data-cls-dd]').forEach(function (o) { o.classList.remove('is-open'); });
  }

  function resetState() {
    state.category = 'All'; state.sizes = []; state.colors = []; state.availability = 'All'; state.priceMax = 900;
    document.querySelectorAll('[data-cls-cat-opt]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-cls-cat-opt') === 'All'); });
    document.querySelectorAll('[data-cls-size-opt]').forEach(function (b) { b.classList.remove('is-active'); });
    document.querySelectorAll('[data-cls-color-opt]').forEach(function (b) { b.classList.remove('is-active'); });
    document.querySelectorAll('[data-cls-avail-opt]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-cls-avail-opt') === 'All'); });
    document.querySelectorAll('[data-cls-price-range]').forEach(function (i) { i.value = 900; });
    document.querySelectorAll('[data-cls-price-label]').forEach(function (l) { l.textContent = 900; });
    render();
  }

  function initClear() {
    document.querySelectorAll('[data-cls-clear-filters]').forEach(function (btn) {
      btn.addEventListener('click', resetState);
    });
  }

  function initDrawer() {
    var drawer = document.querySelector('[data-cls-drawer]');
    var scrim = document.querySelector('[data-cls-drawer-scrim]');
    function open() { if (drawer) drawer.classList.add('is-open'); if (scrim) scrim.classList.add('is-open'); }
    function close() { if (drawer) drawer.classList.remove('is-open'); if (scrim) scrim.classList.remove('is-open'); }
    document.querySelectorAll('[data-cls-open-drawer]').forEach(function (b) { b.addEventListener('click', open); });
    document.querySelectorAll('[data-cls-close-drawer]').forEach(function (b) { b.addEventListener('click', close); });
    if (scrim) scrim.addEventListener('click', close);
  }

  /* ---------- Chips ---------- */
  function buildChips() {
    var chips = [];
    if (state.category !== 'All') chips.push({ label: state.category, remove: function () { document.querySelector('[data-cls-cat-opt="All"]').click(); } });
    state.sizes.slice().forEach(function (z) { chips.push({ label: 'Size ' + z, remove: function () { document.querySelector('[data-cls-size-opt="' + z + '"]').click(); } }); });
    state.colors.slice().forEach(function (c) { chips.push({ label: COLOR_NAMES[c.toUpperCase()] || c, remove: function () { document.querySelector('[data-cls-color-opt="' + c + '"]').click(); } }); });
    if (state.availability !== 'All') chips.push({ label: state.availability, remove: function () { document.querySelector('[data-cls-avail-opt="All"]').click(); } });
    if (state.priceMax < 900) chips.push({ label: 'Under $' + state.priceMax, remove: function () { state.priceMax = 900; document.querySelectorAll('[data-cls-price-range]').forEach(function (i) { i.value = 900; }); document.querySelectorAll('[data-cls-price-label]').forEach(function (l) { l.textContent = 900; }); render(); } });

    var row = document.querySelector('[data-cls-chip-row]');
    if (!row) return;
    row.innerHTML = '';
    chips.forEach(function (c) {
      var b = document.createElement('button');
      b.className = 'cls-w-chip';
      b.innerHTML = c.label + ' <span>&times;</span>';
      b.addEventListener('click', c.remove);
      row.appendChild(b);
    });

    var hasFilters = chips.length > 0;
    document.querySelectorAll('[data-cls-clear-filters].cls-w-clear-btn').forEach(function (b) { b.classList.toggle('is-visible', hasFilters); });
    row.style.display = hasFilters ? 'flex' : 'none';
  }

  /* ---------- Render (filter + sort + count) ---------- */
  function cardMatches(card) {
    var category = card.getAttribute('data-category');
    var price = parseFloat(card.getAttribute('data-price')) || 0;
    var sizes = (card.getAttribute('data-sizes') || '').split(',').filter(Boolean);
    var colors = (card.getAttribute('data-colors') || '').split(',').filter(Boolean).map(function (c) { return c.toUpperCase(); });
    var stock = (card.getAttribute('data-stock') || '').split(',').filter(Boolean);
    var available = card.getAttribute('data-available') === 'true';

    if (state.category !== 'All' && category !== state.category) return false;
    if (price > state.priceMax) return false;
    if (state.sizes.length && !state.sizes.some(function (z) { return sizes.indexOf(z) >= 0; })) return false;
    if (state.colors.length && !state.colors.some(function (c) { return colors.indexOf(c.toUpperCase()) >= 0; })) return false;
    if (state.availability === 'In Stock' && !available) return false;
    if (state.availability === 'Sold Out' && available) return false;
    return true;
  }

  function render() {
    buildChips();
    var totalVisible = 0;
    document.querySelectorAll('[data-cls-grid-section]').forEach(function (section) {
      var grid = section.querySelector('[data-cls-grid]');
      if (!grid) return;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-cls-card]'));
      cards.forEach(function (card) {
        var match = cardMatches(card);
        card.classList.toggle('is-hidden', !match);
        if (match) totalVisible++;
      });
      var visibleCards = cards.filter(function (c) { return !c.classList.contains('is-hidden'); });
      if (state.sort === 'low' || state.sort === 'high') {
        visibleCards.sort(function (a, b) {
          var pa = parseFloat(a.getAttribute('data-price')) || 0;
          var pb = parseFloat(b.getAttribute('data-price')) || 0;
          return state.sort === 'low' ? pa - pb : pb - pa;
        });
        visibleCards.forEach(function (c) { grid.appendChild(c); });
      } else if (state.sort === 'new') {
        visibleCards.slice().reverse().forEach(function (c) { grid.appendChild(c); });
      } else {
        visibleCards.sort(function (a, b) { return (parseInt(a.getAttribute('data-tint'), 10) || 0) - (parseInt(b.getAttribute('data-tint'), 10) || 0); });
      }
      var empty = section.querySelector('[data-cls-empty]');
      if (empty) empty.classList.toggle('is-visible', visibleCards.length === 0);
    });
    document.querySelectorAll('[data-cls-result-count], [data-cls-result-count-2]').forEach(function (el) { el.textContent = totalVisible; });
  }

  /* ---------- Favorites ---------- */
  function initFavorites() {
    document.querySelectorAll('[data-cls-fav]').forEach(function (btn) {
      var card = btn.closest('[data-cls-card]');
      if (!card) return;
      var id = card.getAttribute('data-id');
      btn.classList.toggle('is-fav', !!wishlist[id]);
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        wishlist[id] = !wishlist[id];
        btn.classList.toggle('is-fav', !!wishlist[id]);
        localStorage.setItem('cls_wishlist', JSON.stringify(wishlist));
        showToast((wishlist[id] ? card.getAttribute('data-name') + ' saved to wishlist' : card.getAttribute('data-name') + ' removed from wishlist'));
      });
    });
  }

  /* ---------- Quick add ---------- */
  function initQuickAdd() {
    document.querySelectorAll('[data-cls-quickadd]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var card = btn.closest('[data-cls-card]');
        if (!card) return;
        var available = card.getAttribute('data-available') === 'true';
        var name = card.getAttribute('data-name');
        if (!available) { showToast('We will email you when ' + name + ' returns'); return; }
        addToCart(card.getAttribute('data-id'), 1, function (ok) {
          showToast(ok ? name + ' added to your bag' : 'Could not add ' + name + ' — please try again');
        });
      });
    });
  }

  function addToCart(productGid, qty, cb) {
    var handle = null;
    var card = document.querySelector('[data-cls-card][data-id="' + productGid + '"]');
    if (card) handle = card.getAttribute('data-handle');
    if (!handle) { cb(false); return; }
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var variantId = p.variants && p.variants[0] && p.variants[0].id;
        if (!variantId) throw new Error('no variant');
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        bumpBagCount(qty);
        cb(true);
      })
      .catch(function () { cb(false); });
  }

  function bumpBagCount(qty) {
    var el = document.querySelector('.cls-bag-count');
    if (!el) return;
    var n = parseInt(el.textContent, 10) || 0;
    el.textContent = n + qty;
  }

  /* ---------- Quick view ---------- */
  var qvState = { card: null, color: 0, size: null, qty: 1 };

  function openQuickView(card) {
    qvState.card = card;
    qvState.color = 0;
    var stock = (card.getAttribute('data-stock') || '').split(',').filter(Boolean);
    var sizes = (card.getAttribute('data-sizes') || '').split(',').filter(Boolean);
    qvState.size = stock[0] || sizes[0] || null;
    qvState.qty = 1;
    renderQuickView();
    var scrim = document.querySelector('[data-cls-qv-scrim]');
    var panel = document.querySelector('[data-cls-qv-panel]');
    if (scrim) scrim.classList.add('is-open');
    if (panel) panel.classList.add('is-open');
  }

  function closeQuickView() {
    var scrim = document.querySelector('[data-cls-qv-scrim]');
    var panel = document.querySelector('[data-cls-qv-panel]');
    if (scrim) scrim.classList.remove('is-open');
    if (panel) panel.classList.remove('is-open');
  }

  function renderQuickView() {
    var card = qvState.card;
    if (!card) return;
    var name = card.getAttribute('data-name');
    var price = parseFloat(card.getAttribute('data-price')) || 0;
    var oldPriceRaw = card.getAttribute('data-old-price');
    var category = card.getAttribute('data-category');
    var blurb = card.getAttribute('data-blurb');
    var caption = card.getAttribute('data-caption');
    var tint = card.getAttribute('data-tint');
    var colors = (card.getAttribute('data-colors') || '').split(',').filter(Boolean);
    var sizes = (card.getAttribute('data-sizes') || '').split(',').filter(Boolean);
    var stock = (card.getAttribute('data-stock') || '').split(',').filter(Boolean);
    var available = card.getAttribute('data-available') === 'true';

    setText('[data-cls-qv-name]', name);
    setText('[data-cls-qv-cat]', category);
    setText('[data-cls-qv-price]', money(price));
    setText('[data-cls-qv-old-price]', oldPriceRaw ? money(parseFloat(oldPriceRaw)) : '');
    setText('[data-cls-qv-desc]', blurb + ' Cut in limited quantities and finished by hand, with a fit designed to sit cleanly over layers.');

    var main = document.querySelector('[data-cls-qv-main]');
    if (main) { main.className = 'cls-w-qv-main cls-w-tint-' + tint; }
    setText('[data-cls-qv-main-caption]', caption + ' — VIEW 0' + 1);

    var thumbs = document.querySelector('[data-cls-qv-thumbs]');
    if (thumbs) {
      thumbs.innerHTML = '';
      for (var i = 0; i < 4; i++) {
        var t = document.createElement('button');
        t.className = 'cls-w-qv-thumb cls-w-tint-' + ((parseInt(tint, 10) + i) % 6) + (i === 0 ? ' is-active' : '');
        t.setAttribute('aria-label', 'View ' + (i + 1));
        thumbs.appendChild(t);
      }
    }

    var colorWrap = document.querySelector('[data-cls-qv-colors]');
    if (colorWrap) {
      colorWrap.innerHTML = '';
      colors.forEach(function (c, i) {
        var b = document.createElement('button');
        b.className = 'cls-w-qv-color' + (i === qvState.color ? ' is-active' : '');
        b.style.background = c;
        b.setAttribute('aria-label', COLOR_NAMES[c.toUpperCase()] || 'Colour');
        b.addEventListener('click', function () { qvState.color = i; renderQuickView(); });
        colorWrap.appendChild(b);
      });
    }
    setText('[data-cls-qv-color-name]', COLOR_NAMES[(colors[qvState.color] || '').toUpperCase()] || 'Ink');

    var sizeWrap = document.querySelector('[data-cls-qv-sizes]');
    if (sizeWrap) {
      sizeWrap.innerHTML = '';
      sizes.forEach(function (z) {
        var inStock = stock.indexOf(z) >= 0;
        var b = document.createElement('button');
        b.className = 'cls-w-qv-size' + (qvState.size === z ? ' is-active' : '') + (!inStock ? ' is-oos' : '');
        b.textContent = z;
        if (!inStock) { b.disabled = true; } else {
          b.addEventListener('click', function () { qvState.size = z; renderQuickView(); });
        }
        sizeWrap.appendChild(b);
      });
    }

    setText('[data-cls-qv-qty-val]', String(qvState.qty));
    var addBtn = document.querySelector('[data-cls-qv-add]');
    if (addBtn) {
      addBtn.textContent = available ? 'Add to Bag — ' + money(price * qvState.qty) : 'Notify Me';
    }
    var favBtn = document.querySelector('[data-cls-qv-fav]');
    if (favBtn) {
      var id = card.getAttribute('data-id');
      favBtn.classList.toggle('is-fav', !!wishlist[id]);
      favBtn.textContent = wishlist[id] ? 'Saved to Wishlist' : 'Add to Wishlist';
    }
  }

  function setText(sel, text) {
    var el = document.querySelector(sel);
    if (el) el.textContent = text;
  }

  function initQuickView() {
    document.querySelectorAll('[data-cls-quickview]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var card = btn.closest('[data-cls-card]');
        if (card) openQuickView(card);
      });
    });
    var closeBtn = document.querySelector('[data-cls-qv-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeQuickView);
    var scrim = document.querySelector('[data-cls-qv-scrim]');
    if (scrim) scrim.addEventListener('click', closeQuickView);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQuickView(); });

    var dec = document.querySelector('[data-cls-qv-qty-dec]');
    var inc = document.querySelector('[data-cls-qv-qty-inc]');
    if (dec) dec.addEventListener('click', function () { qvState.qty = Math.max(1, qvState.qty - 1); renderQuickView(); });
    if (inc) inc.addEventListener('click', function () { qvState.qty = Math.min(9, qvState.qty + 1); renderQuickView(); });

    var favBtn = document.querySelector('[data-cls-qv-fav]');
    if (favBtn) {
      favBtn.addEventListener('click', function () {
        if (!qvState.card) return;
        var id = qvState.card.getAttribute('data-id');
        wishlist[id] = !wishlist[id];
        localStorage.setItem('cls_wishlist', JSON.stringify(wishlist));
        var favCardBtn = qvState.card.querySelector('[data-cls-fav]');
        if (favCardBtn) favCardBtn.classList.toggle('is-fav', !!wishlist[id]);
        renderQuickView();
      });
    }

    var addBtn = document.querySelector('[data-cls-qv-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (!qvState.card) return;
        var available = qvState.card.getAttribute('data-available') === 'true';
        var name = qvState.card.getAttribute('data-name');
        if (!available) { showToast('We will email you when ' + name + ' returns'); return; }
        addToCart(qvState.card.getAttribute('data-id'), qvState.qty, function (ok) {
          if (ok) { showToast(name + ' added to your bag'); closeQuickView(); }
          else { showToast('Could not add ' + name + ' — please try again'); }
        });
      });
    }
  }

  /* ---------- Recently viewed drag-scroll ---------- */
  function initCarousel() {
    var el = document.querySelector('[data-cls-carousel]');
    if (!el) return;
    var down = false, startX = 0, startScroll = 0, moved = false;
    el.addEventListener('pointerdown', function (e) { down = true; moved = false; startX = e.clientX; startScroll = el.scrollLeft; el.classList.add('is-dragging'); });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      el.scrollLeft = startScroll - dx;
    }, { passive: true });
    window.addEventListener('pointerup', function () { down = false; el.classList.remove('is-dragging'); });
    el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    syncToolbarOffset();
    window.addEventListener('resize', syncToolbarOffset);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    initDropdowns();
    initSort();
    initCategory();
    initSize();
    initColor();
    initAvailability();
    initPrice();
    initDensity();
    initClear();
    initDrawer();
    initFavorites();
    initQuickAdd();
    initQuickView();
    initCarousel();
    render();
  });
})();
